export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-stretch">
      {/* Left: Text Content */}
      <div className="w-full lg:w-1/2 flex items-center bg-background-50 px-6 md:px-12 lg:px-16 pt-20 pb-10">
        <div className="w-full max-w-xl">
          <p className="font-label text-xs md:text-sm uppercase tracking-[0.2em] text-accent-500 mb-4 md:mb-6">
            Curated Shopping Resource
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-950 leading-[1.1] mb-6">
            Best Superbuy
            <br />
            Spreadsheet
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-foreground-500 mt-2">
              2026 Shopping Guide
            </span>
          </h1>
          <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
            Discover thousands of handpicked products across 14 categories. Compare prices,
            check real QC photos, and shop with confidence — all from one powerful spreadsheet.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <span>Buy It Now</span>
              <span className="w-8 h-8 rounded-full border border-background-50/30 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 border-2 border-foreground-950/15 text-foreground-800 font-label text-sm font-semibold rounded-full hover:border-primary-500 hover:text-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Superbuy Spreadsheet
            </a>
          </div>
        </div>
      </div>

      {/* Right: Product Image */}
      <div className="hidden lg:flex w-1/2 relative bg-background-100 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/5 z-10"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20curated%20fashion%20product%20flatlay%20photography%20featuring%20premium%20sneakers%20soft%20hoodies%20leather%20bags%20and%20delicate%20accessories%20artistically%20arranged%20on%20a%20warm%20textured%20cream%20linen%20surface%2C%20soft%20natural%20window%20light%20from%20the%20left%20creating%20gentle%20highlights%2C%20clean%20minimalist%20aesthetic%20with%20contemporary%20Scandinavian%20influence%2C%20neutral%20earthy%20color%20palette%20with%20warm%20beige%20sand%20and%20soft%20olive%20tones%2C%20editorial%20catalog%20style%20photography%20with%20shallow%20depth%20of%20field%20and%20organic%20thoughtfully%20spaced%20composition&width=900&height=1200&seq=hero-right-v3&orientation=portrait"
          alt="Curated fashion products collection featuring sneakers, hoodies, bags and accessories in an artistic flatlay arrangement"
          title="Superbuy Spreadsheet - Curated Product Collection"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}